import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ProvisioningService } from '../../services/provisioning/provisioning.service';
import { ToastService } from '../../services/toast/toast.service';
import { LoaderComponent } from '../../atoms/loader/loader.component';
import { downloadBookingSlip } from '../../common-files/pdf';

@Component({
  selector: 'app-provision-requisition-search',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, LoaderComponent],
  templateUrl: './provision-requisition-search.component.html',
  styleUrls: ['./provision-requisition-search.component.scss', '../../../common-style/dropdown.scss'],
})
export class ProvisionRequisitionSearchComponent {
  searchType = new FormControl<'aadhaar' | 'id'>('aadhaar', { nonNullable: true });
  searchValue = new FormControl('');

  results: any[] = [];
  hasSearched: boolean = false;
  isLoading: boolean = false;

  constructor(
    private provisioningService: ProvisioningService,
    private toastService: ToastService
  ) {}

  search(): void {
    const value = (this.searchValue.value || '').trim();
    if (!value) {
      this.toastService.error('Enter a value to search.');
      return;
    }
    this.isLoading = true;
    const done = (rows: any[]) => {
      this.results = rows;
      this.hasSearched = true;
      this.isLoading = false;
    };
    const fail = (err: any) => {
      this.results = [];
      this.hasSearched = true;
      this.isLoading = false;
      this.toastService.error(err?.error?.message || 'Search failed.');
    };

    if (this.searchType.value === 'id') {
      this.provisioningService.searchById(Number(value)).subscribe({
        next: (res: any) => done(res?.data?.requisitionId ? [res.data] : []),
        error: fail,
      });
    } else {
      this.provisioningService.searchByAadhaar(value).subscribe({
        next: (res: any) => done(res?.data?.requisitionDetails || []),
        error: fail,
      });
    }
  }

  // download the booking slip as a PDF (fetches the full detail first)
  downloadSlip(row: any): void {
    this.isLoading = true;
    this.provisioningService.searchById(Number(row.requisitionId)).subscribe({
      next: async (res: any) => {
        this.isLoading = false;
        if (res?.data?.requisitionId) await downloadBookingSlip(res.data);
        else this.toastService.error('Could not load the booking detail.');
      },
      error: (err: any) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to build the slip.');
      },
    });
  }
}
